export default __webpack_public_path__ + "static/media/bs.7dbd1c16.svg";